<template>
  <Input
    :id="poll.uid"
    type="number"
    :value="results[questionnaireUid].answers[poll.uid].answer[0]"
  />
</template>

<script>
import { mapActions } from 'vuex'
import Input from '../inputs/Input'

export default {
  name: 'Number',
  components: { Input },
  props: {
    poll: {
      type: Object,
      required: true
    },
    results: Object,
    questionnaire: Boolean,
    questionnaireUid: String
  },
  methods: {
    ...mapActions('questionnaire', ['SET_ANSWER_ACTION']),
    handleInput (value) {
      this.SET_ANSWER_ACTION({ uid: this.questionnaireUid, answerUid: this.poll.uid, answer: [value], type: this.poll.type })
    }
  }
}
</script>

<style scoped>

</style>
